import { useState } from "react";
import { useListBaseOpenContracts, TradingContract } from "@/lib/api/otc";
import { DataTable } from "@/components/ui/DataTable/index";
import { getOtcContractColumns } from "@/section/contracts/shared/OtcContractColumns";
import { useOtcContractHandlers } from "@/section/contracts/shared/useOtcContractHandlers";
import { OtcContractModals } from "@/section/contracts/shared/OtcContractModals";
import { OtcContractDetailModal } from "@/section/otc/contract-detail-view";

export function StagedOtcContracts() {
  const {
    isUnstaging,
    isDeleting,
    unstageModalId,
    deleteModalId,
    setUnstageModalId,
    setDeleteModalId,
    confirmUnstagePrompt,
    confirmDeletePrompt,
    onUnstage,
    onDelete,
  } = useOtcContractHandlers();

  // Fetch staged contracts
  const stagedContractsRes = useListBaseOpenContracts({
    staged_for_review: true,
    filters: {},
  });

  const stagedContracts = stagedContractsRes?.data?.data || [];
  const isLoading = stagedContractsRes?.isLoading;

  const [detailContractId, setDetailContractId] = useState<string | null>(null);

  // Handler for row clicks to open the layered contract detail modal by id.
  const handleRowClick = (row: TradingContract, _columnId?: string) => {
    setDetailContractId(row.id ?? null);
  };

  // Columns with action buttons for staged contracts
  const columns = getOtcContractColumns({
    showUnstageButton: true,
    showDeleteButton: true,
    onUnstage: (id: string) => confirmUnstagePrompt({ id }),
    onDelete: (id: string) => confirmDeletePrompt({ id }),
  });

  return (
    <div className="w-full">
      <OtcContractModals
        unstageModalId={unstageModalId}
        deleteModalId={deleteModalId}
        setUnstageModalId={setUnstageModalId}
        setDeleteModalId={setDeleteModalId}
        isUnstaging={isUnstaging}
        isDeleting={isDeleting}
        onUnstage={onUnstage}
        onDelete={onDelete}
      />

      {/* Layered contract detail modal (view/edit by id) */}
      <OtcContractDetailModal
        open={detailContractId !== null}
        contract_id={detailContractId}
        onClose={() => setDetailContractId(null)}
      />

      <DataTable
        stickyHeaders
        tableClassName="max-h-[calc(100vh-400px)] overflow-y-scroll"
        data={stagedContracts}
        columns={columns}
        enableSorting
        enableMultiSort
        enableFiltering
        enableGrouping
        filterStyle="select"
        filterMode="internal"
        emptyMessage={
          isLoading ? "Loading..." : "No staged contracts for review"
        }
        rowClickable={true}
        onRowClick={handleRowClick}
      />
    </div>
  );
}
